import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { MediaQuery } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { getLocalizedValue } from '@grandvisionhq/utils';
import { getActiveVariant } from '../../helpers.js';
import { ReadyReaders } from './ReadyReaders.js';
import { useBrandLink } from '../utils/use-brand-link.js';

const ReadyReadersContainer = ({ activeSku , addToCartRef , handleConversionEvent , onCTAClick , product , showStickyButton , variant , storesRoute  })=>{
    var ref;
    const { getLabel , locale  } = useIntl();
    const brandLink = useBrandLink(product);
    const isMobile = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const activeVariant = getActiveVariant(product, activeSku);
    const productImageAlt = getLocalizedValue(product.name, locale);
    var ref1;
    const stockCount = (ref1 = (ref = variant.availability) === null || ref === void 0 ? void 0 : ref.availableQuantity) !== null && ref1 !== void 0 ? ref1 : 0;
    const isOrderable = (variant === null || variant === void 0 ? void 0 : variant.channelAvailability) === 'ONLINE';
    const variants = React.useMemo(()=>[
            product.masterVariant,
            ...product.variants
        ]
    , [
        product.masterVariant,
        product.variants
    ]);
    const handleVariantPick = (selectedSize)=>{
        DataLayer.pushEvent({
            event: 'readyreaders',
            eventAction: 'pdp select lens power',
            eventLabel: selectedSize
        });
    };
    const labels = React.useMemo(()=>({
            informationBlockHeader: getLabel('products.readyreaders.informationBlockHeader'),
            power: getLabel('products.readyreaders.power')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(ReadyReaders, {
        activeSku: activeSku,
        activeVariant: activeVariant,
        addToCartRef: addToCartRef,
        brandLink: brandLink,
        handleConversionEvent: handleConversionEvent,
        handleVariantPick: handleVariantPick,
        isMobile: isMobile,
        isOrderable: isOrderable,
        labels: labels,
        onCTAClick: onCTAClick,
        product: product,
        productImageAlt: productImageAlt,
        showStickyButton: showStickyButton,
        stockCount: stockCount,
        variant: variant,
        variants: variants,
        storesRoute: storesRoute
    });
};

export { ReadyReadersContainer };
//# sourceMappingURL=ReadyReadersContainer.js.map
